import { Content } from '@/services/contents/content.vm';
import { Route } from '@/services/routes/route.vm';
import { Stage } from '@/services/stages/stage.vm';

export enum ContentsActionTypes {
  // Route Contents
  LOAD_LEARNING_PATH_CONTENTS = 'LOAD_LEARNING_PATH_CONTENTS',
  LOAD_LEARNING_CONTENT = 'LOAD_LEARNING_CONTENT',
  ADD_CONTENT = 'ADD_CONTENT',
  UPDATE_CONTENT = 'UPDATE_CONTENT',
  DELETE_CONTENT = 'DELETE_CONTENT',

  // Stages
  LOAD_STAGE_CONTENTS = 'LOAD_STAGE_CONTENTS',
  LOAD_STAGE_CONTENT = 'LOAD_STAGE_CONTENT',
  ADD_STAGE_CONTENT = 'ADD_STAGE_CONTENT',
  UPDATE_STAGE_CONTENT = 'UPDATE_STAGE_CONTENT',
  DELETE_STAGE_CONTENT = 'DELETE_STAGE_CONTENT',
}

// Route Contents Actions

type LoadLearningPathContentsAction = {
  type: ContentsActionTypes.LOAD_LEARNING_PATH_CONTENTS;
  payload: { routeId: Route['id']; contents: Content[] };
};

type LoadLearningContentAction = {
  type: ContentsActionTypes.LOAD_LEARNING_CONTENT;
  payload: { routeId: Route['id']; contentId: Content['id']; content: Content };
};

type AddContentAction = {
  type: ContentsActionTypes.ADD_CONTENT;
  payload: { routeId: Route['id']; content: Content };
};

type UpdateContentAction = {
  type: ContentsActionTypes.UPDATE_CONTENT;
  payload: { routeId: Route['id']; contentId: Content['id']; content: Partial<Content> };
};

type DeleteContentAction = {
  type: ContentsActionTypes.DELETE_CONTENT;
  payload: { routeId: Route['id']; contentId: Content['id'] };
};

// Stages Contents Actions

type LoadStageContentsAction = {
  type: ContentsActionTypes.LOAD_STAGE_CONTENTS;
  payload: { routeId: Route['id']; stageId: Stage['id']; contents: Content[] };
};

type LoadStageContentAction = {
  type: ContentsActionTypes.LOAD_STAGE_CONTENT;
  payload: { routeId: Route['id']; stageId: Stage['id']; contentId: Content['id']; content: Content };
};

type AddStageContentAction = {
  type: ContentsActionTypes.ADD_STAGE_CONTENT;
  payload: { routeId: Route['id']; stageId: Stage['id']; content: Content };
};

type UpdateStageContentAction = {
  type: ContentsActionTypes.UPDATE_STAGE_CONTENT;
  payload: { routeId: Route['id']; stageId: Stage['id']; contentId: Content['id']; content: Partial<Content> };
};

type DeleteStageContentAction = {
  type: ContentsActionTypes.DELETE_STAGE_CONTENT;
  payload: { routeId: Route['id']; stageId: Stage['id']; contentId: Content['id'] };
};

export type ContentsAction =
  | LoadLearningPathContentsAction
  | LoadLearningContentAction
  | AddContentAction
  | UpdateContentAction
  | DeleteContentAction
  | LoadStageContentsAction
  | LoadStageContentAction
  | AddStageContentAction
  | UpdateStageContentAction
  | DeleteStageContentAction;